export default __webpack_public_path__ + "static/media/error-state.2ece4bdf.svg";